module.exports = __webpack_public_path__ + "static/img/select-bg.bd5097a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/select-bg.png
// module id = VAdF
// module chunks = 1